var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentPendingApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFFAE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69995 9.0498H15.3",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 16.8498V15.6498C8.3999 14.695 8.77919 13.7794 9.45432 13.1042C10.1294 12.4291 11.0451 12.0498 11.9999 12.0498C12.9547 12.0498 13.8704 12.4291 14.5455 13.1042C15.2206 13.7794 15.5999 14.695 15.5999 15.6498V16.8498C15.5999 17.0089 15.5367 17.1615 15.4242 17.2741C15.3116 17.3866 15.159 17.4498 14.9999 17.4498H8.9999C8.84077 17.4498 8.68816 17.3866 8.57564 17.2741C8.46312 17.1615 8.3999 17.0089 8.3999 16.8498Z",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 7.2499V8.4499C8.3999 9.40468 8.77919 10.3204 9.45432 10.9955C10.1294 11.6706 11.0451 12.0499 11.9999 12.0499C12.9547 12.0499 13.8704 11.6706 14.5455 10.9955C15.2206 10.3204 15.5999 9.40468 15.5999 8.4499V7.2499C15.5999 7.09077 15.5367 6.93816 15.4242 6.82564C15.3116 6.71312 15.159 6.6499 14.9999 6.6499H8.9999C8.84077 6.6499 8.68816 6.71312 8.57564 6.82564C8.46312 6.93816 8.3999 7.09077 8.3999 7.2499Z",
    stroke: "#F2B42A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPendingApproval);
export default __webpack_public_path__ + "static/media/payment_pending_approval.549691a18ba8912d660066db01965e7c.svg";
export { ForwardRef as ReactComponent };